export enum HandballThrowBlockedAttribute {
  SixMeter = 1025,
  NineMeter = 1026,
  AfterTurnover = 1027,
  Air = 1028,
  Breakthrough = 1029,
  Center = 1030,
  EmptyNetGoal = 1031,
  FastAttack = 1032,
  Ground = 1033,
  LeftSide = 1034,
  LeftWing = 1035,
  Pivot = 1036,
  RightSide = 1037,
  RightWing = 1038,
}
